<template>
  <div class="daily-view">
    <PageTitleExtra
      :title="displayText.pageTitle"
      :btn="displayText.btn.create"
      :btn2="displayText.btn.togglePeriod"
      :btn3="displayText.btn.settings"
      :btn4="displayText.btn.exportPdf"
      btnFeature="admin.appointmentOrder.create"
      btn2Feature="admin.appointmentScheduleBan.updateTimes"
      :hideBtn="dialog.create"
      @btnClick="onCreateReservation"
      @btn2Click="onTogglePeriod"
      @btn3Click="dialog.settings = true"
      @btn4Click="exportPdf"
    />

    <span v-if="showControl.dialog.create" class="flex items-center mb-[12px]">
      <span class="text-primary-100">★</span>：{{ $t('dailyView.starNote') }}
    </span>

    <DisplaySettingsDialog
      v-if="showControl.dialog.settings"
      :length="unitList.length"
      @close="dialog.settings = false"
      @confirm="onTimeRangeChange"
    />

    <div v-if="!showControl.dialog.create" class="flex justify-between" style="margin-bottom: 12px">
      <FiltersContainer>
        <el-date-picker
          v-model="search.date"
          editable
          style="width: 340px !important"
          type="date"
          :placeholder="displayText.search.date"
        />
        <BaseElSelect
          v-model="search.unit"
          style="width: 340px !important"
          filterable
          clearable
          :placeholder="displayText.search.unit"
          value-key="id"
          @change="searchUnitChange"
          @clear="delayGenerateCellBlock"
        >
          <BaseElSelectOption
            v-for="unit in unitList"
            :key="unit.id"
            :label="unit.name"
            :value="unit"
          />
        </BaseElSelect>
        <span class="flex items-center">
          <span class="text-primary-100">★</span>：{{ $t('dailyView.starNote') }}
        </span>
      </FiltersContainer>

      <Pagination
        v-if="showControl.pagination"
        style="padding: 0"
        :curPage="page + 1"
        :pageLimit="perPage"
        :total="unitList.length"
        @pageChange="changePage"
      />
    </div>

    <FlexLayout :gap="20">
      <div class="flex-1">
        <vue-cal
          v-if="showControl.showCal"
          v-loading="loading"
          :time-from="startPeriodTime || 0"
          :time-to="lastPeriodTime || 1440"
          :timeCellHeight="columnHeight"
          style="width: 100%"
          :style="{
            height: dialog.create ? '700px' : '100%'
          }"
          active-view="day"
          hide-view-selector
          :selected-date="search.date"
          :events="composEvents"
          :disable-views="['years', 'year', 'month', 'week']"
          :split-days="chunkUnitColumn[page]"
          :sticky-split-labels="true"
          :on-event-click="onEventClick"
          :editable-events="false"
          :time-step="timeUnit"
          @view-change="dateChange"
        >
          <template #title="{ title, view }">
            <div class="relative">
              <p>{{ formateTitle(title, view) }}</p>
              <span
                class="material-icons absolute cursor-pointer"
                style="top: 5px; right: -280px"
                @click="search.date = new Date()"
              >
                event_outlined
              </span>
            </div>
          </template>

          <template #time-cell="{ hours, minutes }">
            <div :class="{ 'vuecal__time-cell-line': true, hours: !minutes }">
              <strong v-if="!minutes">{{ hours }}:{{ plusZero(minutes) }}</strong>
              <span v-else class="text-sub">{{ hours }}:{{ plusZero(minutes) }}</span>
            </div>
          </template>

          <template #split-label="{ split }">
            <div class="flex flex-col text-center truncate w-full">
              <p class="truncate w-full break-words" :style="`color: ${split.color}`">{{ split.label }}</p>
              <p class="w-full">({{ split.reservationCount }})</p>
            </div>
          </template>

          <template #event="{ event }">
            <div v-if="event.isMore">...</div>
            <div v-else>
              <div class="vuecal__event-time hidden" />
              <div v-if="event.data" :style="`border-radius: 2px; padding: 4px; font-size: ${settings.textSize}px;`">
                <div class="flex justify-between items-center">
                  <span v-if="event.data.hasComment" class="mr-[4px]">★</span>
                  <p v-if="showControl.reservationTime">
                    {{ formatDate(event.start, 'HH:mm') }} - {{ formatDate(event.end, 'HH:mm') }}
                  </p>
                  <!-- <Tag  class="flex-wrap" type="info">不指定</Tag> -->
                  <div v-if="event.data.fromNotSpecify" class="tag flex">
                    <span>{{ $t('dailyView.notSpecify') }}</span>
                  </div>
                </div>
                <p v-if="showControl.name">{{ event.data.newUserName || displayText.unfilled }}</p>
                <p v-if="showControl.birthday">{{ event.data.numberCode === 1 ? (get(event.data, 'Member.UserInfo.birthday') ? formatDate(get(event.data, 'Member.UserInfo.birthday'), 'YYYY/MM/DD') : '') : '' }}</p>
                <p v-if="showControl.phone">{{ event.data.userPhone || displayText.unfilled }}</p>
                <p v-if="showControl.serviceName">{{ get(event.reservation, 'AppointmentService.name') }}</p>
                <p v-for="service in showAttachServices(event.reservation)" :key="service">{{ service }}</p>
              </div>
            </div>
          </template>
        </vue-cal>
      </div>
      <!-- <div v-if="showControl.dialog.create" class="overflow-y-auto create-reservation-wrapper">
        <CreateReservationBlock
          :selectUnit="select.unit"
          :selectDate="select.start"
          :selectPeriod="select.period"
          @close="handleCloseCreateReservation"
          @unitChange="createUnitChange"
          @created="dateChange({startDate: curStart})"
        />
      </div> -->

      <div v-if="showControl.dialog.create" v-loading="loadingControl.createReservationArea" class="create-reservation-wrapper">
        <FlexLayout col :gap="20">
          <p class="font-medium text-primary-100 text-lg">{{ $t('dailyView.form.createTitle') }}</p>

          <div class="section-block">
            <FlexLayout col :gap="10">
              <p><span class="text-gray-80">{{ $t('dailyView.form.servicePersonnel') }}</span>{{ select.unit ? select.unit.name : '-' }}</p>
              <p><span class="text-gray-80">{{ $t('dailyView.form.reservationDate') }}</span>{{ select.start ? formatDate(select.start, 'YYYY/MM/DD') : '-' }}</p>
              <p><span class="text-gray-80">{{ $t('dailyView.form.reservationTime') }}</span>{{ select.period ? select.period : '-' }}</p>
            </FlexLayout>
          </div>

          <NewCreateAppointment
            ref="createReservationBlockRef"
            embedMode
            :preset="{
              serviceUnit: select.unit,
              date: select.start,
              period: select.period,
            }"
            @close="handleCloseCreateReservation"
            @created="dateChange({startDate: curStart})"
          />
        </FlexLayout>
      </div>
    </FlexLayout>

    <!-- <AppointmentDrawer
      v-if="showControl.dialog.create"
      :context="select"
      @close="dialog.create = false"
    /> -->
    <!-- @close="handleCloseCreateReservation" -->

    <!-- 預約資訊側邊彈窗 -->
    <ReservationOrderDetail
      v-if="showControl.dialog.info"
      :orderId="select.event.id"
      :selecReservation="select.event"
      :enableCancelReasonCollection="enableCancelReasonCollection"
      @close="dialog.info=false"
      @cancel="onCancel"
      @refresh="dateChange({startDate: curStart})"
    />

    <!-- 關閉時段 Dialog -->
    <TogglePeriodDialog
      v-if="showControl.dialog.togglePeriod"
      :title="displayText.dialog.toggle.title"
      width="440px"
      :selectUnit="select.unit"
      :selectDate="select.start"
      @close="dialog.togglePeriod = false"
      @updated="dateChange({startDate: curStart})"
    />

    <DeleteDialog
      v-if="showControl.dialog.delete"
      :title="displayText.dialog.delete.title"
      :content="deleteContent"
      width="40%"
      :btnString="displayText.btn.cancel"
      :cancelBtnString="displayText.btn.return"
      @close="dialog.delete = false"
      @delete="cancelReservation"
    />

    <WarningDialog
      v-if="showControl.dialog.noShift"
      :content="displayText.dialog.noShift.content"
      :btnString="displayText.btn.cancel"
      @close="dialog.noShift = false"
      @confirm="goToUnitSchedule"
    />
  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import { defineComponent, ref, reactive, computed, watch, onMounted, set } from 'vue'
import { useStorage } from '@vueuse/core'
import PageTitleExtra from '@/components/Title/PageTitleExtra.vue'
import DisplaySettingsDialog from './components/DisplaySettingsDialog.vue'
import ReservationOrderDetail from '@/components/Reservation/ReservationOrderDetail/ReservationOrderDetail.vue'
import TogglePeriodDialog from '@/components/Dialog/TogglePeriodDialog.vue'
import WarningDialog from '@/components/Dialog/WarningDialog.vue'

// import { mapGetters } from 'vuex'
import { GetServiceUnit } from '@/api/serviceUnit'
import { FindReservationParameter, GetReservation, GetReservationCount, UpdateReservationOrderStatus } from '@/api/reservation'
import { GetPeriods } from '@/api/togglePeriod'

import { checkFeature } from '@/store/modules/permission'
import { formatDate, weekDayTranslate } from '@/utils/date'
import { generateTimes, getAllDataFromApi, passValue, plusZero, timeToNumber } from '@/utils/helper'
import dayjs from '@/lib/dayjs'
import { get, map, find, flattenDeep, chunk, includes, forEach, filter, some } from 'lodash'
import debounce from 'lodash.debounce'
import { useShop } from '@/use/shop'
import store from '@/store'
import { useRouter } from 'vue-router/composables'
import JsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import notifyMessage from '@/config/notifyMessage'
import NewCreateAppointment from '../NewCreateAppointment/NewCreateAppointment.vue'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'DailyView',
  components: {
    VueCal,
    ReservationOrderDetail,
    TogglePeriodDialog,
    WarningDialog,
    PageTitleExtra,
    DisplaySettingsDialog,
    NewCreateAppointment,
  },
  setup () {
    const { shopId } = useShop()
    const router = useRouter()
    const loading = ref(false)
    const deleteContent = ref('')
    const createReservationBlockRef = ref(null)
    const unitList = ref([])
    const curView = ref('all')
    const loadingControl = reactive({
      createReservationArea: false,
    })

    const settings = useStorage('dailyViewSettings',
      {
        start: '00:00',
        end: '24:00',
        unitPerPage: 5,
        columnHeight: 180,
        textSize: 12,
        displayItem: ['phone', 'name', 'birthday', 'reservationTime', 'serviceName'],
      },
      localStorage,
      { mergeDefaults: true },
    )

    const displayItem = ref(get(settings.value, 'displayItem'))
    const columnHeight = ref(get(settings.value, 'columnHeight'))
    const page = ref(0)
    const perPage = ref(get(settings.value, 'unitPerPage'))
    const curStart = ref(null)
    const timeUnit = ref(60)
    const timeOffset = ref(0)
    const enableCancelReasonCollection = ref(false)
    const showCal = ref(true)
    const startPeriodTime = ref(timeToNumber(get(settings.value, 'start')))
    const lastPeriodTime = ref(timeToNumber(get(settings.value, 'end')))

    const search = reactive({
      unit: null,
      date: new Date(),
    })
    const select = reactive({
      start: null,
      unit: null,
      event: null,
      period: null,
    })
    const dialog = reactive({
      create: false,
      info: false,
      togglePeriod: false,
      noShift: false,
      delete: false,
      settings: false,
    })
    const userFeatures = computed(() => get(store.getters, 'userFeatures'))
    const unitColumn = computed(() => {
      const unitColumn = map(unitList.value, (unit) => ({
        id: unit.id,
        label: unit.name,
        reservationCount: unit.reservationCount,
      }))

      return unitColumn
    })
    const chunkUnitColumn = computed(() => {
      const unitChunk = chunk(unitColumn.value, perPage.value)

      if (search.unit) {
        unitChunk[page.value] = unitChunk[page.value].filter(i => i.id.includes(search.unit.id))
      }
      return unitChunk
    })
    const composEvents = computed(() => {
      return flattenDeep(map(unitList.value, 'events').filter(i => Boolean(i)))
    })
    const filteredEvents = computed(() => {
      const eventMap = new Map()
      const overlapCountMap = new Map()
      const unitId = event.split

      // const todayEvents = filter(composEvents.value, filterTodayEvents)
      const todayEvents = composEvents.value
      todayEvents.sort((a, b) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf())

      forEach(todayEvents, event => {
        const unitId = event.split

        const overlappingEvents = []
        for (const e of todayEvents) {
          if (e.split === unitId && dayjs(event.start).isBefore(dayjs(e.end)) && dayjs(event.end).isAfter(dayjs(e.start))) {
            overlappingEvents.push(e)
          }
        }

        const timeSlotKey = map(overlappingEvents, e => `${e.start}-${e.end}`).sort().join('|')

        if (!eventMap.has(timeSlotKey)) {
          eventMap.set(timeSlotKey, [])
        }
        const events = eventMap.get(timeSlotKey)

        if (!overlapCountMap.has(unitId)) {
          overlapCountMap.set(unitId, 0)
        }

        let overlapCount = overlapCountMap.get(unitId)
        if (perPage.value >= 6 && !search.unit) {
          if (some(events, e => e.split === unitId && dayjs(event.start).isBefore(dayjs(e.end)) && dayjs(event.end).isAfter(dayjs(e.start)))) {
            overlapCount += 1
          }

          if (overlapCount < 3) {
            events.push(event)
          } else if (overlapCount === 3) {
            events.push({ ...event, isMore: true })
          }
          overlapCountMap.set(unitId, overlapCount)
        } else {
          events.push(event)
        }
      })

      return flattenDeep(
        Array.from(eventMap.values()).map(events => {
          const moreEvent = events.find(event => event.isMore)
          return moreEvent ? [moreEvent, ...filter(events, event => !event.isMore)] : events
        }),
      )
    })
    const periods = computed(() => {
      return generateTimes(timeUnit.value, timeOffset.value)
    })
    const displayText = computed(() => {
      const data = {
        pageTitle: t('dailyView.pageTitle'),
        btn: {
          create: t('dailyView.btn.create'),
          togglePeriod: t('dailyView.btn.togglePeriod'),
          settings: t('dailyView.btn.settings'),
          exportPdf: t('dailyView.btn.exportPdf'),
          cancel: t('dailyView.btn.cancel'),
          return: t('dailyView.btn.return'),
          goShift: t('dailyView.btn.goShift'),
        },
        search: {
          date: t('dailyView.search.date'),
          unit: t('dailyView.search.unit'),
        },
        unfilled: t('dailyView.unfilled'),
        dialog: {
          toggle: {
            title: t('dailyView.dialog.toggle.title'),
          },
          delete: {
            title: t('dailyView.dialog.delete.title'),
          },
          noShift: {
            content: t('dailyView.dialog.noShift.content'),
          },
        },
      }
      return data
    })
    const showControl = computed(() => {
      const item = displayItem.value
      const controls = {
        pagination: !search.unit,
        showCal: showCal.value,
        reservationTime: includes(item, 'reservationTime'),
        name: includes(item, 'name'),
        phone: includes(item, 'phone'),
        birthday: includes(item, 'birthday'),
        serviceName: includes(item, 'serviceName'),
        dialog: {
          create: dialog.create,
          info: dialog.info,
          togglePeriod: dialog.togglePeriod,
          noShift: dialog.noShift,
          delete: dialog.delete,
          settings: dialog.settings,
        },
      }
      return controls
    })
    watch(unitColumn, () => {
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    })
    watch(page, () => {
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    })
    watch(startPeriodTime, () => {
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    })
    watch(lastPeriodTime, () => {
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    })
    // const filterTodayEvents = (event) => {
    //   return dayjs(event.start).isSame(dayjs(search.date), 'day') && dayjs(event.end).isSame(dayjs(search.date), 'day')
    // }
    const getDailyViewSettings = () => {
      startPeriodTime.value = timeToNumber(get(settings.value, 'start'))
      lastPeriodTime.value = timeToNumber(get(settings.value, 'end'))
      perPage.value = get(settings.value, 'unitPerPage')
      displayItem.value = get(settings.value, 'displayItem')
      columnHeight.value = get(settings.value, 'columnHeight')
    }
    const onTimeRangeChange = () => {
      showCal.value = false
      getDailyViewSettings()
      dateChange({ startDate: curStart.value })
      generateCellBlock()
      showCal.value = true
      dialog.settings = false
      window.$message.success(notifyMessage.updateSuccess)
    }
    const handleCloseCreateReservation = () => {
      curView.value = 'all'
      dialog.create = false
      search.unit = null
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    }
    const searchUnitChange = (e) => {
      const unitColumn = map(unitList.value, 'id')
      const chunkColumn = chunk(unitColumn, perPage.value)

      for (const curePage in chunkColumn) {
        if (chunkColumn[curePage].includes(e.id)) {
          const curPage = passValue(page.value)
          page.value = Number(curePage)
          if (curPage === page.value) {
            setTimeout(() => {
              generateCellBlock()
            }, 300)
          }
          return
        }
      }
    }
    const getReservationConfig = async () => {
      try {
        const res = await FindReservationParameter({ shopId: shopId.value })
        timeUnit.value = res.timeUnit || 60
        timeOffset.value = res.timeUnitOffset || 0
        enableCancelReasonCollection.value = get(res, 'enableCancelReasonCollection', false)
      } catch (e) {
        console.log(`getReservationConfig error: ${e}`)
      }
    }
    const onTogglePeriod = () => {
      select.unit = null
      select.start = null
      dialog.togglePeriod = true
    }
    const onCreateReservation = () => {
      curView.value = 'detail'
      const target = chunkUnitColumn.value[page.value][0]
      const unit = find(unitList.value, { id: target.id })
      select.unit = unit
      search.unit = unit
      select.start = new Date(curStart.value)
      select.period = undefined
      dialog.create = true
      setTimeout(() => {
        generateCellBlock()
      }, 500)
    }
    const createUnitChange = (unit) => {
      search.unit = unit
      searchUnitChange(unit)
    }
    const changePage = (curPage) => {
      page.value = curPage - 1
      search.unit = null
    }
    const goToUnitSchedule = () => {
      router.push({
        name: 'ShiftsCalendar',
        query: {
          unit: select.unit,
          date: formatDate(select.start),
          from: 'DailyView',
        },
      })
    }
    const formateTitle = (title, view) => {
      const date = formatDate(view.startDate, 'YYYY/MM/DD')
      const day = weekDayTranslate(dayjs(view.startDate).day())

      return `${date} ${day}`
    }
    const onEventClick = (event, e) => {
      if (event.isMore) {
        const unit = find(unitList.value, { id: event.split })
        search.unit = unit
        return
      }
      // 跨日凌晨延續的透明背景事件（class: shift）不處理點擊，交由底層 cell-block 建立預約
      if (event.class === 'shift') return
      select.unit = event.split
      select.start = event.start
      if (event.noShift) {
        dialog.noShift = true
        return
      }
      if (event.disabled) {
        dialog.togglePeriod = true
        return
      }
      select.event = event.reservation
      dialog.info = true
    }
    const generateCellBlock = () => {
      console.log('generateCellBlock')
      const cols = document.querySelectorAll('[data-split]')
      cols.forEach(el => {
        const unitId = el.getAttribute('data-split')
        const unit = find(unitList.value, { id: unitId })
        const target = document.querySelector(`[data-split="${unit.id}"]`)
        const oldCellBlocks = Array.from(target.children).filter(i => Array.from(i.classList).includes('cell-block'))
        const noEventBlock = Array.from(target.children).filter(i => Array.from(i.classList).includes('vuecal__no-event'))
        if (noEventBlock.length) target.removeChild(noEventBlock[0])
        oldCellBlocks.forEach(i => target.removeChild(i))
        periods.value.forEach(period => {
          if (timeToNumber(period) >= startPeriodTime.value && timeToNumber(period) < lastPeriodTime.value) {
            const block = document.createElement('div')
            block.style.height = `${columnHeight.value}px`
            block.classList.add('cell-block')
            block.addEventListener('click', () => {
              if (!checkFeature(userFeatures.value, 'admin.appointmentOrder.create')) return

              // 檢查是否為空檔時段且早於當前時間
              const selectedDateTime = dayjs(`${dayjs(curStart.value).format('YYYY-MM-DD')} ${period}`)
              const currentDateTime = dayjs()

              if (selectedDateTime.isBefore(currentDateTime)) {
                window.$message.warning(t('dailyView.noShiftWarning'))
                return
              }

              search.unit = unit
              select.unit = unit
              select.start = curStart.value
              select.period = period

              if (curView.value === 'detail') {
                loadingControl.createReservationArea = true
                if (createReservationBlockRef.value) createReservationBlockRef.value.onReset()
                const wrapperContainer = get(createReservationBlockRef.value, '$el.parentElement')
                if (wrapperContainer) {
                  wrapperContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  })
                }
                setTimeout(() => {
                  loadingControl.createReservationArea = false
                }, 300)
              } else {
                dialog.create = true
                curView.value = 'detail'
              }

              setTimeout(() => {
                generateCellBlock()
              }, 500)
            })
            target.appendChild(block)
          }
        })
      })
    }
    const getServiceUnit = async () => {
      try {
        unitList.value = await GetServiceUnit({
          shopId: shopId.value,
        })
      } catch (error) {
        console.log(error)
        window.$message.error({
          message: error || error.message,
        })
      }
    }
    const getUnitDayPeriods = async (unit, date) => {
      const res = await GetPeriods({
        shopId: shopId.value,
        appointmentUnitId: unit.id,
        start: dayjs(date).startOf('date').toDate(),
        end: dayjs(date).endOf('date').toDate(),
      })
      const targetUnit = find(unitList.value, { id: unit.id })
      if (targetUnit) set(targetUnit, 'times', res.times)
      if (!res.times.length) {
        set(targetUnit, 'events', [
          {
            start: dayjs(date).startOf('date').toDate(),
            end: dayjs(date).endOf('date').toDate(),
            allDay: true,
            class: 'no-shift',
            split: targetUnit.id,
            disabled: true,
            noShift: true,
            background: true,
          },
        ])
      }
      if (res.times.length) {
        createPeriodEvents(targetUnit, res.times)
      }
    }
    // 依 times（後端回傳的排班時段）在整個時間軸鋪出背景事件。
    // 逐格掃描 startPeriod ~ endPeriod，將連續相同狀態合併成一個區塊：
    //  - available：可預約，維持白底可點；一般時段不補背景事件（靠 cell-block 呈現白底），
    //    但「跨日凌晨延續」時段會落在格線起點，手機版 split-days 窄欄位需有事件才會 render，
    //    故僅對「落在格線起點的第一段」補一個透明背景事件（class: shift），
    //    點擊仍交由底層 cell-block 處理（樣式設定 pointer-events: none）。
    //  - noShift：未排班，反灰。
    //  - ban / booking：不可預約，反灰斜線。
    const createPeriodEvents = (unit, times) => {
      if (!times.length) return
      const startPeriod = periodToDate(periods.value[0])
      const endPeriod = periodToDate(periods.value[periods.value.length - 1])
      const step = timeUnit.value

      const statusAt = (slot) => {
        const target = find(times, t => dayjs(t.start).isSame(slot))
        return target ? target.status : 'noShift'
      }
      const pushRun = (status, runStart, runEnd, isFirstRun) => {
        if (!runStart || !runEnd || !runEnd.isAfter(runStart)) return
        if (status === 'available') {
          // 只有落在格線起點的可預約時段（跨日凌晨延續）需補透明背景事件；
          // 其餘可預約時段維持無背景（白底），行為與原本一致。
          if (isFirstRun) {
            unit.events.push({
              start: runStart.toDate(),
              end: runEnd.toDate(),
              class: 'shift',
              split: unit.id,
              background: true,
            })
          }
          return
        }
        const isNoShift = status === 'noShift'
        const event = {
          start: runStart.toDate(),
          end: runEnd.toDate(),
          class: isNoShift ? 'no-shift' : 'disabled',
          split: unit.id,
          disabled: true,
          background: true,
        }
        if (isNoShift) event.noShift = true
        unit.events.push(event)
      }

      let cur = dayjs(startPeriod)
      const gridEnd = dayjs(endPeriod)
      let runStatus = null
      let runStart = null
      let isFirstRun = true
      while (cur.isBefore(gridEnd)) {
        const status = statusAt(cur)
        if (status !== runStatus) {
          if (runStatus !== null) {
            pushRun(runStatus, runStart, cur, isFirstRun)
            isFirstRun = false
          }
          runStatus = status
          runStart = cur
        }
        cur = cur.add(step, 'm')
      }
      if (runStatus !== null) pushRun(runStatus, runStart, gridEnd, isFirstRun)
    }
    const dateChange = debounce(async (e) => {
      search.date = e.startDate
      loading.value = true
      curStart.value = new Date(e.startDate)
      select.start = new Date(e.startDate)
      for (const unit of unitList.value) {
        set(unit, 'events', [])
        set(unit, 'times', [])
        set(unit, 'reservationCount', 0)
        getUnitDayPeriods(unit, new Date(e.startDate))
      }
      await getReservation(new Date(e.startDate))
      loading.value = false
    }, 300, { leading: false, trailing: true })

    const periodToDate = (period) => {
      const now = dayjs(curStart.value).format('YYYY/MM/DD')
      return dayjs(`${now} ${period}`).toDate()
    }
    const getReservation = async (date) => {
      const payload = {
        shopId: shopId.value,
        dateStart: dayjs(date).startOf('date').toDate(),
        dateEnd: dayjs(date).endOf('date').toDate(),
      }
      const count = await GetReservationCount(payload)
      const getReservation = async (payload) => {
        try {
          return await GetReservation(payload)
        } catch (err) {
          window.$message.error(err)
          return []
        }
      }
      const res = await getAllDataFromApi(count, getReservation, { ...payload, limit: 300, start: 0 })
      const reservations = res.filter(i => get(i, 'AppointmentOrder.status') !== 'cancel')
      reservations.forEach(i => createReservationEvents(i))
    }
    const onCancel = (data, cancelReason) => {
      // 取消原因由抽屜內部的彈窗收集後一併帶回，直接送出
      if (cancelReason) {
        cancelReservation(cancelReason)
        return
      }
      const orders = get(data, 'AppointmentOrder.AppointmentReservations')
      const orderCode = get(data, 'AppointmentOrder.code')
      if (!orders) {
        dialog.delete = true
        deleteContent.value = t('dailyView.cancelConfirm')
        return
      }
      if (!orders.length || orders.length === 1) {
        dialog.delete = true
        deleteContent.value = t('dailyView.cancelConfirm')
        return
      }
      const ordersCount = orders.length
      deleteContent.value = t('dailyView.cancelOrderConfirm', { code: orderCode, count: ordersCount })
      dialog.delete = true
    }
    const cancelReservation = async ({ cancelReasonCode, cancelReasonNote } = {}) => {
      dialog.delete = false
      const [, err] = await UpdateReservationOrderStatus({
        shopId: shopId.value,
        id: get(select.event, 'AppointmentOrder.id'),
        status: 'cancel',
        cancelReasonCode,
        cancelReasonNote,
      })
      if (err) return window.$message.error(err)
      dialog.info = false
      await dateChange({ startDate: curStart.value })
    }
    const createReservationEvents = (reservation) => {
      if (!reservation) return
      const {
        AppointmentOrder,
        AppointmentUnit,
        numberCode,
        Member,
        start,
        end,
        userName,
        userPhone,
        fromNotSpecify,
      } = reservation
      const newUserName = get(AppointmentOrder, 'origin') === 'pubApt' ? `(訪客)${userName}` : userName
      const unitId = get(AppointmentUnit, 'id')
      if (!unitId) return
      const data = {
        title: '',
        data: {
          newUserName,
          userPhone,
          fromNotSpecify,
          Member,
          numberCode,
          hasComment: Boolean(get(reservation, 'AppointmentOrder.adminComment') || get(reservation, 'AppointmentOrder.userComment')),
        },
        start: new Date(start),
        end: new Date(end),
        split: unitId || 'noUnit',
        class: AppointmentOrder.status,
        reservation,
      }
      const target = find(unitList.value, { id: unitId })
      if (target) {
        if (!target.events) {
          target.events = []
        }

        const isDuplicate = some(target.events, (event) => event.start === start && event.end === end)
        if (!isDuplicate) {
          target.events.push(data)
          target.reservationCount = filter(target.events, event => event.reservation).length
        }
      }
    }
    const showAttachServices = (reservation) => {
      const data = get(reservation, 'AppointmentServiceAttaches')
      const services = map(data, i => i.name)
      return services
    }
    const exportPdf = async () => {
      const targetDom = document.querySelector('.vuecal')

      // Temporarily remove styles causing text truncation
      const truncateElements = targetDom.querySelectorAll('.truncate')
      truncateElements.forEach((el) => {
        el.style.overflow = 'visible'
        el.style.textOverflow = 'unset'
        el.style.whiteSpace = 'normal'
      })

      await html2canvas(targetDom, {
        scale: 1,
        useCORS: true,
        imageTimeout: 1000,
        height: targetDom.scrollHeight,
        width: targetDom.scrollWidth,
        dpi: window.devicePixelRatio,
      }).then(canvas => {
        const A4_WIDTH = 841.89
        const A4_HEIGHT = 592.28
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        const pageData = canvas.toDataURL()
        // 一页pdf html页面生成的canvas高度;
        const pageHeight = contentWidth / A4_WIDTH * A4_HEIGHT
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight
        // 页面偏移
        let position = 0
        const margin = 20
        const imgWidth = A4_WIDTH - margin * 2
        const imgHeight = (A4_WIDTH - margin * 2) / contentWidth * contentHeight
        const pdf = new JsPDF('l', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, 'JPEG', margin, margin, imgWidth, imgHeight, '', 'FAST')
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', margin, position + margin, imgWidth, imgHeight, '', 'FAST')
            leftHeight -= pageHeight
            position -= A4_HEIGHT
            // 避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }
        // 直接下载
        pdf.save(`${t('dailyView.pageTitle')}.pdf`)
      })

      // Restore original styles
      truncateElements.forEach((el) => {
        el.style.overflow = ''
        el.style.textOverflow = ''
        el.style.whiteSpace = ''
      })
    }

    const delayGenerateCellBlock = () => {
      setTimeout(() => {
        generateCellBlock()
      }, 300)
    }

    onMounted(async () => {
      store.commit('app/SET_SIDEBAR', false)
      getDailyViewSettings()
      await getReservationConfig()
      await getServiceUnit()
      dateChange({
        startDate: new Date(),
      })
      generateCellBlock()
    })
    return {
      settings,
      loading,
      deleteContent,
      unitList,
      page,
      perPage,
      curStart,
      timeUnit,
      timeOffset,
      showCal,
      startPeriodTime,
      lastPeriodTime,
      search,
      select,
      dialog,
      unitColumn,
      chunkUnitColumn,
      composEvents,
      filteredEvents,
      periods,
      plusZero,
      get,
      formatDate,
      onTimeRangeChange,
      handleCloseCreateReservation,
      searchUnitChange,
      onTogglePeriod,
      onCreateReservation,
      createUnitChange,
      changePage,
      goToUnitSchedule,
      formateTitle,
      onEventClick,
      dateChange,
      onCancel,
      cancelReservation,
      enableCancelReasonCollection,
      showAttachServices,
      displayItem,
      columnHeight,
      exportPdf,
      displayText,
      showControl,
      createReservationBlockRef,
      loadingControl,
      delayGenerateCellBlock,
    }
  },
})
</script>

<style lang="scss" scoped>
.daily-view {
  padding-bottom: 0 !important;
}
::v-deep .vuecal {
  @apply rounded-[10px];
}

::v-deep .day-view {
  @apply bg-white;
}

::v-deep .vuecal__bg {
  @apply bg-primary-30 ;
}

::v-deep .vuecal__body {
  @apply rounded-tl-[0px] rounded-tr-[0px] rounded-bl-[10px] rounded-br-[10px];
}

::v-deep .vuecal__header {
  @apply bg-primary-30 rounded-tl-[10px] rounded-tr-[10px];
}

::v-deep .vuecal__title-bar {
  @apply flex justify-center bg-primary-100 text-white h-[60px];
  @apply rounded-tl-[10px] rounded-tr-[10px];
}

::v-deep .day-split-header {
  // @apply border-gray-50 border-r border-t-0;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  flex: 1;
}
.break-words {
  word-break: break-word;
  white-space: normal!important;
}
::v-deep .vuecal__flex {
  .vuecal__title {
    @apply flex-none w-auto;
  }
  .vuecal__split-days-headers {
    @apply h-auto bg-primary-30 ml-[60px] border-gray-40 border;
  }
}

::v-deep .vuecal__cell-split {
  @apply border-r border-r-gray-50;
}
::v-deep .vuecal__event {
  @apply border-[4px] border-l-[8px] rounded-[4px] cursor-pointer text-left text-[12px];
}
::v-deep .vuecal__event.no-shift{
  @apply bg-gray-40 border-none opacity-60;
}
/* 跨日凌晨延續的可預約時段：透明白底，僅為讓手機版窄欄位 render，
   點擊穿透至底層 cell-block（維持可預約） */
::v-deep .vuecal__event.shift{
  @apply bg-transparent border-none;
  pointer-events: none;
}
::v-deep .vuecal__event.disabled{
  background: repeating-linear-gradient(-45deg, transparent, transparent 5px, var(--gray-50) 5px, var(--gray-50) 11px);/* IE 10+ */
  @apply text-gray-80 flex justify-center items-center ;
  @apply bg-gray-40 border-none opacity-60;
}

::v-deep .vuecal__event.wait{
  @apply bg-[#FBF2E7] border-[#E4A65F];
}
::v-deep .vuecal__event.cancel{
  @apply bg-danger-light border-danger;
}
::v-deep .vuecal__event.confirm{
  @apply bg-[#E1EDF9] border-[#3788D8];
}
::v-deep .vuecal__event.complete{
  @apply bg-[#F4F7E2] border-[#B5C93E];
}

::v-deep .vuecal__time-column {
  @apply w-[60px] bg-primary-30 ;
}

.create-reservation-wrapper {
  @apply border border-primary-100 p-[12px] rounded-[10px] flex-shrink-0;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  // height: 700px;
  @apply flex-1 max-w-[650px];
  // @apply overflow-x-auto;
  // width: 800px;
}

::v-deep .cell-block {
  @apply hover:bg-primary-30;
}
.tag {
  @apply border border-info text-info bg-info-light p-[2px] rounded-[4px] text-center;
  @apply w-[fit-content];
}

</style>
